
    // JQUERY.MAGNIFIC-POPUP
    if ($.fn.magnificPopup) {
        // image
        $('.image-popup').magnificPopup({type:'image'});
        $('.image-group-popup').each(function() {
            $(this).magnificPopup({
                delegate: 'a',
                type: 'image',
                gallery: {
                    enabled: true
                }
            });
        });
        // iframe
        $('.iframe-popup').magnificPopup({type:'iframe'});
		$('.iframe-group-popup').each(function() {
			$(this).magnificPopup({
				delegate: 'a',
				type: 'iframe',
				gallery: {
					enabled: true
				}
			});
		});

		$('.zoom-gallery').each(function() {
			$(this).magnificPopup({
				delegate: 'a',
				type: 'image',
				closeOnContentClick: false,
				closeBtnInside: false,
				overflowY: 'scroll',
				mainClass: 'mfp-img-mobile',
				image: {
					verticalFit: true,
				},
				gallery: {
					enabled: true
				},
				// zoom: {
				// 	enabled: true,
				// 	duration: 300,
				// 	opener: function(element) {
				// 		return element.find('img');
				// 	}
				// },
				fixedContentPos: false,
				callbacks: {
					open: function() {
						jQuery('body').addClass('noscroll');
					},
					close: function() {
						jQuery('body').removeClass('noscroll');
					}
				}
			});
		});
    
        $('.gallery-wrapper').magnificPopup({
                delegate: 'div a',
                type: 'image',
                gallery: {
                        enabled: true,
                        //navigateByImgClick: true
                },
                //fixedContentPos: false
        });

    }
